import cdnApi from './cdn';
import countryApi from './country';

const pluginAPI = {
	install(Vue) {
		Vue.prototype.$cdnAPI = cdnApi;
		Vue.prototype.$countryAPI = countryApi;
	},
};

export default pluginAPI;
